import { handleGoogleLoginReq } from "../../redux/user-slices/auth.slice"
import { Box, Button, CircularProgress, Icon } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import Icons from "../../assets/js/Icons"
import { useEffect } from "react"

function GoogleLogin({handleClose, stay  }) {
  const dispatch = useDispatch()
  const { loadings } = useSelector(state => state.authSlice)
  const _handleClose = handleClose || (() => {})
  const handleCredentialResponse = (response) => {
    const token = response?.credential
     stay = stay || null
    dispatch(handleGoogleLoginReq({ token,stay}))

_handleClose()
  }

  useEffect(() => {
    const initializeGoogleSignIn = () => {
      if (window.google && window.google.accounts) {
        window.google.accounts.id.initialize({
          callback: handleCredentialResponse,
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          scope: "https://www.googleapis.com/auth/calendar.events",
        })

        window.google.accounts.id.renderButton(
          document.getElementById("googleSignIn"),
          { theme: "outline", size: "large" }
        )
         
      } else {
        setTimeout(initializeGoogleSignIn, 100)
         
         
      }
    }

    initializeGoogleSignIn()
    // eslint-disable-next-line
  }, [])

  return (
    <Box position="relative" overflow="hidden">
      <Button
        sx={{
          p: "9px 13px",
          width: "100%",
          fontWeight: "400",
          lineHeight: "1.2",
          position: "relative",
          justifyContent: "center",
          bgcolor: "#dd4b39 !important",
          "svg": { fontSize: "16px !important" }
        }}
        size="small"
        type="button"
        variant="contained"
        startIcon={
          <Icon sx={{ fontSize: "16px !important" }}>
            <Icons.Google />
          </Icon>
        }
        endIcon={
          loadings?.googleLogin &&
          <CircularProgress
            thickness={6}
            size={22}
            color="text"
          />
        }
      >Login
      </Button>
      <Box
        id="googleSignIn"
        sx={{
          top: "0",
          left: "0",
          opacity: "0.01",
          position: "absolute",
          "iframe": {
            m: "0 !important",
            width: "100% !important",
          }
        }}
      />
    </Box>
  )
}

export default GoogleLogin